/**
 * Labstep
 *
 * @module components/Protocol/Form/ShowEdit/State/Container/Edit
 * @desc State showedit edit container
 */

import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import type React from 'react';
import { useCallback, useEffect, useState } from 'react';
import type { IProtocolFormShowEditStateContainerEditProps } from './types';

export const ProtocolFormShowEditStateContainerEdit: React.FC<
  IProtocolFormShowEditStateContainerEditProps
> = ({ entity, children }) => {
  const canEdit = useHasAccess(
    entity.entityName,
    entity.id,
    Action.edit,
    'state',
  );

  const [editing, setEditing] = useState(
    canEdit && entity.hasEmptyState,
  );

  const setEditMode = useCallback((): void => {
    if (canEdit) {
      setEditing(true);
    }
  }, [canEdit]);

  const setViewMode = useCallback((): void => setEditing(false), []);

  useEffect(() => {
    if (!canEdit && editing) {
      setEditing(false);
    }
  }, [canEdit]);

  return children({ canEdit, editing, setEditMode, setViewMode });
};
